import { render, staticRenderFns } from "./card-big.vue?vue&type=template&id=98d4414c&"
import script from "./card-big.vue?vue&type=script&lang=ts&"
export * from "./card-big.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports